import script from "./ViewMyChildrenAttendanceDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewMyChildrenAttendanceDialog.vue?vue&type=script&setup=true&lang=js"

import "./ViewMyChildrenAttendanceDialog.vue?vue&type=style&index=0&id=4b5be2d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b5be2d6"]])

export default __exports__